import { useEffect } from "react";

import { useScrollIntoView } from "src/utils/useScrollIntoView";

const SCROLL_CONFIG = {
  visibilityMargin: 0,
} as const;

export const useHighlightedScrollIntoView = <
  T extends HTMLElement = HTMLDivElement,
>(
  isSearchHighlighted?: boolean,
) => {
  const { ref, scrollIntoView } = useScrollIntoView<T>(SCROLL_CONFIG);

  useEffect(() => {
    if (isSearchHighlighted) {
      scrollIntoView();
    }
  }, [isSearchHighlighted]);

  return [ref];
};
